<template>
    <flex-element>
        <div :class="`f-relative ${!hasMobileTransition ? 'f-flex' : 'f-flex mob:f-hidden tab:f-hidden'} component__div f-h-1/1`">
            <o-container
                v-bind="element(1)"
                style="-webkit-overflow-scrolling: touch"
                @element-updated="elementUpdated"
            >
                <template v-slot="{ elementUpdated, elementsNew}">
                    <tab-container
                        v-for="(element, index) in elementsNew"
                        :key="element.id"
                        :class="{ [STATE_CLASSES.SELECTED]: isActiveIndex(index)}"
                        v-bind="element"
                        :index="index"
                        :pointer="index + 1"
                        @element-updated="elementUpdated"
                        @click.native="onTabClick(index)"
                    >
                        <!-- eslint-disable-next-line vue/no-template-shadow -->
                        <template v-slot="{ elementUpdated, elementsNew }">
                            <div class="f-flex f-flex-wrap f-bg-transparent f-h-1/1">
                                <component
                                    :is="innerElement.elementType"
                                    v-for="(innerElement, innerIndex) in elementsNew"
                                    :key="innerElement.id"
                                    :pointer="innerIndex + 1"
                                    :index="innerIndex"
                                    v-bind="innerElement"
                                    @element-updated="elementUpdated"
                                />
                            </div>
                        </template>
                    </tab-container>
                </template>
            </o-container>
            <o-container
                ref="panes"
                v-bind="element(2)"
                :display-name="`Tab Panes Container`"
                @element-updated="elementUpdated"
            >
                <template v-slot="{ elementUpdated, elementsNew }">
                    <tab-pane-container
                        v-for="(element, index) in elementsNew"
                        v-show="isActiveIndex(index)"
                        :key="element.id"
                        :index="index"
                        :pointer="index + 1"
                        v-bind="element"
                        @element-updated="elementUpdated"
                    >
                        <!-- eslint-disable-next-line vue/no-template-shadow -->
                        <template v-slot="{ elementUpdated, elementsNew }">
                            <div class="f-flex f-flex-wrap f-bg-transparent">
                                <component
                                    :is="innerElement.elementType"
                                    v-for="(innerElement, innerIndex) in elementsNew"
                                    :key="innerElement.id"
                                    :pointer="innerIndex + 1"
                                    :index="innerIndex"
                                    v-bind="innerElement"
                                    @element-updated="elementUpdated"
                                />
                            </div>
                        </template>
                    </tab-pane-container>
                </template>
            </o-container>
        </div>
        <div :class="`f-relative ${hasMobileTransition ? 'f-hidden mob:f-block tab:f-block': 'f-hidden'} component__div f-h-1/1`">
            <transition :name="!isOpenTab ? 'slidelclose' : 'slidelopen'">
                <o-container
                    v-show="!isOpenTab"
                    v-bind="element(1)"
                    style="display: block"
                    class-default="f-flex tabs__section f-items-center f-bg-transparent f-min-h-4 f-min-w-4"
                    @element-updated="elementUpdated"
                >
                    <template v-slot="{ elementUpdated, elementsNew}">
                        <tab-container
                            v-for="(element, index) in elementsNew"
                            :key="element.id"
                            class-default="f-block f-z-1 f-items-center f-flex-grow f-bg-transparent f-cursor-pointer f-flex-grow f-items-center f-w-1/1 f-min-h-4 f-min-w-4"
                            v-bind="element"
                            :index="index"
                            :pointer="index + 1"
                            @element-updated="elementUpdated"
                            @click.native="onTabClick(index, elementsNew)"
                        >
                            <!-- eslint-disable-next-line vue/no-template-shadow -->
                            <template v-slot="{ elementUpdated, elementsNew }">
                                <div class="f-flex f-flex-wrap f-bg-transparent f-h-1/1 f-relative dynamic-nav-tab-go">
                                    <component
                                        :is="innerElement.elementType"
                                        v-for="(innerElement, innerIndex) in elementsNew"
                                        :key="innerElement.id"
                                        :pointer="innerIndex + 1"
                                        :index="innerIndex"
                                        v-bind="innerElement"
                                        @element-updated="elementUpdated"
                                    />
                                    <span class="right-chevron"><font-awesome-icon :icon="['fal', 'chevron-right']" /></span>
                                </div>
                            </template>
                        </tab-container>
                    </template>
                </o-container>
            </transition>
            <transition :name="isOpenTab ? 'sliderclose' : 'slideropen'">
                <o-container
                    v-show="isOpenTab"
                    ref="panes"
                    v-bind="element(2)"
                    class-default="f-flex f-bg-transparent f-min-h-4 f-min-w-4"
                    :display-name="`Tab Panes Container`"
                    @element-updated="elementUpdated"
                >
                    <template v-slot="{ elementUpdated, elementsNew }">
                        <tab-pane-container
                            v-for="(element, index) in elementsNew"
                            v-show="isActiveIndex(index)"
                            :key="element.id"
                            class-default="f-relative f-bg-transparent f-w-1/1 f-min-h-4 f-min-w-4"
                            :index="index"
                            :pointer="index + 1"
                            v-bind="element"
                            @element-updated="elementUpdated"
                        >
                            <!-- eslint-disable-next-line vue/no-template-shadow -->
                            <template v-slot="{ elementUpdated, elementsNew }">
                                <div v-show="isOpenTab" class="f-flex f-flex-wrap f-bg-transparent">
                                    <div
                                        class="f-items-center f-bg-bc-7 selected:f-bg-bc-1 f-cursor-pointer f-block tab:f-h-1/1 f-max-h-5 f-min-w-4 mob:f-min-w-14 tab:f-min-w-22 f-pr-0.5 lap:f-pr-0.25 f-relative f-w-1/1 f-z-1"
                                        :style="`
                                            background-image:
                                                linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)),
                                                url('https://seattlesymphony-dev-cm.flexaccelerator.com/-/media/images/homepage-hero/stripes-vertical-long.png?rev=fbc3ad835d6d458b9a38c40db421696c');
                                                background-size: auto;
                                                background-repeat: no-repeat;
                                                color: white;
                                                font-weight: 600;
                                            `"
                                        @click="closeTabContent()"
                                    >
                                        <div class="f-flex f-items-start tab:f-items-start lap:f-items-start f-flex-col f-flex-wrap f-h-1/1 tab:f-h-1/1 f-justify-center tab:f-justify-center lap:f-justify-center f-min-h-4 f-pl-2 f-relative f-w-1/1 f-z-1">
                                            <span v-html="openTabTitle" />
                                            <span class="dynamic-nav-tab-back">
                                                <font-awesome-icon :icon="['fal', 'chevron-left']" />
                                                <font-awesome-icon :icon="['fal', 'bars']" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="f-flex f-flex-wrap f-bg-transparent">
                                    <component
                                        :is="innerElement.elementType"
                                        v-for="(innerElement, innerIndex) in elementsNew"
                                        :key="innerElement.id"
                                        :pointer="innerIndex + 1"
                                        :index="innerIndex"
                                        v-bind="innerElement"
                                        @element-updated="elementUpdated"
                                    />
                                </div>
                            </template>
                        </tab-pane-container>
                    </template>
                </o-container>
            </transition>
        </div>
    </flex-element>
</template>

<script>
import uniqid from 'uniqid';

import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import { STATE_CLASSES } from '@/data/constants/classes';

const CUSTOM_ATTR_NAME = 'tabbed-nav-transition';

export default {
    name: 'advanced-tabbed-nav',
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Advanced Tabbed Nav',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            currentTabIndex: 0,
            openTabIndex: -1,
            openTabTitle: '',
            isOpenTab: false,
            itemId: uniqid(),
            STATE_CLASSES,
            hasMobileTransition: false,
        };
    },

    mounted() {
        this.hasMobileTransition = this.getElementData(CUSTOM_ATTR_NAME);
    },

    methods: {
        onTabClick(clickedIndex, element) {
            if (element) { // Get title for mobile tab back
                const { richText } = element[clickedIndex].elements[0].elements[0];
                this.openTabTitle = richText;
            }
            if (clickedIndex === this.openTabIndex) {
                this.isOpenTab = false;
            } else {
                this.isOpenTab = true;
            }
            this.openTabIndex = clickedIndex;
            this.currentTabIndex = clickedIndex;
        },

        closeTabContent() {
            this.isOpenTab = false;
            this.openTabIndex = -1;
        },

        isActiveIndex(index) {
            return index === this.currentTabIndex;
        },
    },
};
</script>

<style lang="scss">
    .slidelopen-leave-active,
    .slidelopen-enter-active {
        position: absolute !important;
        transition: .5s;
    }
    .slidelopen-enter {
        transform: translate(100%, 0);
        position: absolute;
    }
    .slidelopen-leave-to {
        transform: translate(-100%, 0);
        position: absolute !important;
    }

    .slideropen-leave-active,
    .slideropen-enter-active {
        transition: .5s;
    }
    .slideropen-enter {
        transform: translate(100%, 0);
    }
    .slideropen-leave-to {
        transform: translate(-100%, 0);
    }

    .slidelclose-leave-active,
    .slidelclose-enter-active {
        position: absolute !important;
        transition: .5s;
    }
    .slidelclose-enter {
        transform: translate(-100%, 0);
        position: absolute;
    }
    .slidelclose-leave-to {
        transform: translate(100%, 0);
        position: absolute !important;
    }

    .sliderclose-leave-active,
    .sliderclose-enter-active {
        transition: .5s;
    }
    .sliderclose-enter {
        transform: translate(100%, 0);
    }
    .sliderclose-leave-to {
        transform: translate(-100%, 0);
    }

    .dynamic-nav-tab-back {
        position: absolute;
        right: 1rem;
        svg {
            &:first-child {
                margin-right: 5px;
            }
        }
    }
    .dynamic-nav-tab-go {
        span.right-chevron {
            color: white;
            display: none;
            position: absolute;
            right: 1rem;
            top: 1.3rem;
        }
        &:hover {
            span.right-chevron {
                display: inline-block;
            }
        }
    }
</style>
